import AddNewPositionWizard from './AddNewPositionWizard';

export default AddNewPositionWizard;
